<div class="member-container">
    <div class="member-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/user_card_red.png" alt="user card Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Detail du client @if(member){ / <strong class="username">{{ member.firstName + " " + member.lastName }}</strong>}</span>
            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="goToList()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>
    <div class="member-details-container">
        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des détails du client...</p>
        </div>

        <!-- Error state -->
        <div *ngIf="!isLoading && errorMessage" class="error-state">
            <div class="error-icon">!</div>
            <p class="error-message">{{ errorMessage }}</p>
            <button class="retry-button" (click)="goToList()">Retour à la liste</button>
        </div>


        <div *ngIf="!isLoading && member && !errorMessage" class="member-card-container">
            <div class="member-card">
                <div class="member-image-col">
                    <img [src]="member.profileImage || './assets/images/icons/user-default-icon.png'" [alt]="member.firstName" class="member-image" [class.full]="member.profileImage" (error)="setDefaultImage($event)">
                </div>

                <div class="member-content-col">
                    <div class="col-header">
                        <div class="left-side">
                            <h3 class="member-title">{{ member.firstName + " " + member.lastName }}</h3>
                            <p class="member-description">
                                {{ member.phoneNumber }}
                            </p>
                            <p class="member-description">
                                {{ member.email }}
                            </p>
                            <p class="member-description">
                                {{ formatAddress(member.address) }}
                            </p>

                            <div class="member-infos">
                                <span>Nom de l'entreprise: <span>{{ member.companyName }}</span></span>
                                <span>Numéro de TVA: <span>{{ member.vatNumber }}</span></span>
                            </div>
                        </div>
                        <div class="right-side">
                            <div class="status-badge">
                                <span class="status-dot" [class.public]="member.emailVerified" [class.private]="!member.emailVerified"></span>
                                <span class="status-text">{{ member.emailVerified ? 'Email Vérifié' : 'Email non vérifié' }}</span>
                            </div>
                            <div class="status-badge">
                                <span class="status-dot" [class.public]="member.isEnabled" [class.private]="!member.isEnabled"></span>
                                <span class="status-text">{{ member.isEnabled ? 'Compte activer' : 'Compte Désactiver' }}</span>
                            </div>
                            <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                                <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                            </button>
                        </div>
                    </div>

                    <div class="member-footer">
                        <div class="creation-date">
                            a rejoint le {{ member.createdAt }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="popup-menu" *ngIf="menuOpen">
                <div class="arrow"></div>
                <ul>
                    <li (click)="edit()">
                        <img src="./assets/images/icons/edit.png" alt="View"> Modifier
                    </li>
                    <li (click)="toggleVisibility()">
                        <img class="lock" src="./assets/images/icons/lock-red.png" alt="Visibility"> {{ member.isEnabled ? 'Désactiver le compte' : 'Activer le compte' }}
                    </li>
                    <li (click)="confirmDelete()" class="delete-item">
                        <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
                    </li>
                </ul>
            </div>

            <app-admin-member-reservations-card [reservations]="member.recentReservations"></app-admin-member-reservations-card>
        </div>
    </div>
</div>
<div class="confirmation-modal-overlay" *ngIf="showDeleteModal && member">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir supprimer ce client <br><strong>"{{ member.firstName + " " + member.lastName  }}"</strong> (<small>{{member.email}}</small>) ?</p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteMember()">Supprimer</button>
        </div>
    </div>
</div>